import { render, staticRenderFns } from "./wrongdetail.vue?vue&type=template&id=372882b2&scoped=true&"
import script from "./wrongdetail.vue?vue&type=script&lang=js&"
export * from "./wrongdetail.vue?vue&type=script&lang=js&"
import style0 from "./wrongdetail.vue?vue&type=style&index=0&id=372882b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372882b2",
  null
  
)

export default component.exports